import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["nav", "link"];
  static values = {
    offset: { type: Number, default: 85 },
    offsetMobile: { type: Number, default: 64 },
  };

  connect() {
    this.setupHeroObserver();
    this.setupSectionObserver();
  }

  disconnect() {
    this.heroObserver?.disconnect();
    this.sectionObserver?.disconnect();
  }

  setupHeroObserver() {
    const hero = document.getElementById("hero");
    if (!hero) return;

    this.heroObserver = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          this.navTarget.classList.add(
            "opacity-0",
            "translate-y-4",
            "pointer-events-none",
          );
          this.navTarget.classList.remove("opacity-100", "translate-y-0");
        } else {
          this.navTarget.classList.remove(
            "opacity-0",
            "translate-y-4",
            "pointer-events-none",
          );
          this.navTarget.classList.add("opacity-100", "translate-y-0");
        }
      },
      { threshold: 0 },
    );
    this.heroObserver.observe(hero);
  }

  setupSectionObserver() {
    const sectionIds = new Set();
    this.linkTargets.forEach((link) => {
      const sectionId = link.dataset.sectionNavSectionParam;
      if (sectionId) sectionIds.add(sectionId);
    });

    this.sectionObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.setActive(entry.target.id);
          }
        });
      },
      { rootMargin: "-50% 0px -50% 0px" },
    );

    sectionIds.forEach((id) => {
      const section = document.getElementById(id);
      if (section) this.sectionObserver.observe(section);
    });
  }

  setActive(sectionId) {
    this.linkTargets.forEach((link) => {
      const isCta = link.dataset.sectionNavCtaParam === "true";
      const isActive = link.dataset.sectionNavSectionParam === sectionId;
      const underline = link.querySelector("[data-underline]");

      if (!isCta) {
        link.classList.toggle("text-primary-500", isActive);
      }

      if (underline) {
        underline.classList.toggle("bg-primary-500", isActive);
      }
    });
  }

  scrollTo(event) {
    event.preventDefault();
    const sectionId = event.params.section;
    const section = document.getElementById(sectionId);
    if (!section) return;

    const offset =
      window.innerWidth >= 1024 ? this.offsetValue : this.offsetMobileValue;
    const extraOffset = Number(event.params.extraOffset) || 0;
    const top =
      section.getBoundingClientRect().top +
      window.pageYOffset -
      offset -
      extraOffset;

    window.scrollTo({ top, behavior: "smooth" });
  }
}
